var _style, _defs, _defs2, _defs3, _g, _g2, _defs4, _path, _path2, _rect, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path3, _defs5, _path4, _path5, _g11, _g12, _g13, _g14, _line, _g15, _g16, _g17, _g18, _g19, _text, _text2, _text3, _g20, _g21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumImpact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1165.1px",
    height: "781.5px",
    viewBox: "0 0 1165.1 781.5",
    style: {
      enableBackground: "new 0 0 1165.1 781.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{clip-path:url(#SVGID_00000080198289768382116740000014991010728375825812_);fill:#349EA0;}\n\t.st3{opacity:0.46;}\n\t.st4{clip-path:url(#SVGID_00000008831842495993451690000012374114732796170887_);fill:#349EA0;}\n\t.st5{opacity:0.64;}\n\t.st6{clip-path:url(#SVGID_00000008867583469335463670000015847484041801056946_);fill:#349D9F;}\n\t.st7{fill:none;stroke:#349EA0;stroke-miterlimit:10;}\n\t.st8{display:inline;opacity:0.13;}\n\t.st9{fill:none;stroke:#F1F1F1;stroke-miterlimit:10;}\n\t.st10{opacity:0.58;clip-path:url(#SVGID_00000096740831112597276420000010897708085955396992_);fill:#EAEAEF;}\n\t.st11{display:inline;fill:none;stroke:#CBDA2C;stroke-miterlimit:10;}\n\t.st12{display:inline;fill:none;}\n\t.st13{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FCEF91;}\n\t.st14{font-family:'AzoSans-Medium';}\n\t.st15{font-size:20px;}\n\t.st16{letter-spacing:2;}\n\t.st17{fill:#55BFD6;}\n\t.st18{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st19{fill:#F5DF5E;}\n\t.st20{fill:#F5DF5E;stroke:#FFFFFF;stroke-width:0.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:#F7E15D;}\n\t.st22{fill:#FFFFFF;}\n\t.st23{fill:none;stroke:#FFFFFF;stroke-width:0.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#349EA0;}\n\t.st25{fill:none;stroke:#CBDA2C;stroke-miterlimit:10;}\n\t.st26{fill:#93AC1D;}\n\t.st27{fill:#BE866F;}\n\t.st28{fill:#D8A7A1;}\n\t.st29{fill:#885C4A;}\n\t.st30{fill:#038C6B;}\n\t.st31{fill:none;stroke:#9BD8D9;stroke-width:2;stroke-miterlimit:10;}\n\t.st32{fill:#004736;}\n\t.st33{fill:none;stroke:#ABD7D7;stroke-width:2;stroke-miterlimit:10;}\n\t.st34{fill:#F6E6E0;}\n\t.st35{fill:#E6BEB4;}\n\t.st36{fill:#967F77;}\n\t.st37{fill:none;stroke:#55BFD6;stroke-miterlimit:10;}\n\t.st38{fill:#00B86D;}\n\t.st39{fill:#00B86D;stroke:#FFFFFF;stroke-width:0.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st40{fill:#E9F6F8;}\n\t.st41{fill:#FCE03A;stroke:#FBEF97;stroke-miterlimit:10;}\n\t.st42{font-size:18px;}\n\t.st43{letter-spacing:1;}\n\t.st44{fill:#038D6B;}\n\t.st45{fill:#DE8F7C;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st46{fill:#150F44;}\n\t.st47{fill:#DE8F7C;}\n\t.st48{fill:#AC6A55;}\n\t.st49{fill:#55BFD6;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st50{fill:#427004;}\n\t.st51{fill:#DE8F7C;stroke:#FBEF97;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "BG",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 687,
    y: 258.5,
    width: 309,
    height: 441
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#349EA0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182503202929226577060000002741232389572927635_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 686,
    y: 257.5,
    style: {
      clipPath: "url(#SVGID_00000182503202929226577060000002741232389572927635_)",
      fill: "#349EA0"
    },
    width: 311,
    height: 443
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000110434328026221674700000009073520183617781682_",
    x: 70,
    y: 258.5,
    className: "st3",
    width: 309,
    height: 441
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110434328026221674700000009073520183617781682_",
    style: {
      overflow: "visible",
      fill: "#349EA0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066514393068899793160000001661789285427492533_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110434328026221674700000009073520183617781682_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 257.5,
    style: {
      clipPath: "url(#SVGID_00000066514393068899793160000001661789285427492533_)",
      fill: "#349EA0"
    },
    width: 311,
    height: 443
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098189389249345486490000008905023186196812192_",
    x: 379,
    y: 258.5,
    className: "st5",
    width: 309,
    height: 441
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098189389249345486490000008905023186196812192_",
    style: {
      overflow: "visible",
      fill: "#349D9F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005962759596505767440000000042497166854528388_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098189389249345486490000008905023186196812192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 257.5,
    style: {
      clipPath: "url(#SVGID_00000005962759596505767440000000042497166854528388_)",
      fill: "#349D9F"
    },
    width: 311,
    height: 443
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 258,
    x2: 1119.2,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 321,
    x2: 1119.2,
    y2: 321
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 384.1,
    x2: 1119.2,
    y2: 384.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 447.2,
    x2: 1119.2,
    y2: 447.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 510.2,
    x2: 1119.2,
    y2: 510.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 573.3,
    x2: 1119.2,
    y2: 573.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 636.4,
    x2: 1119.2,
    y2: 636.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 26.7,
    y1: 699.5,
    x2: 1119.2,
    y2: 699.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 258,
    x2: 1119.2,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 321,
    x2: 1119.2,
    y2: 321
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 384.1,
    x2: 1119.2,
    y2: 384.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 447.2,
    x2: 1119.2,
    y2: 447.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 510.2,
    x2: 1119.2,
    y2: 510.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 573.3,
    x2: 1119.2,
    y2: 573.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 636.4,
    x2: 1119.2,
    y2: 636.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 26.7,
    y1: 699.5,
    x2: 1119.2,
    y2: 699.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030473351052440016560000017187056802081284486_",
    x: 70,
    y: 258,
    width: 926,
    height: 442
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130640363040579638010000009138726624572017033_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030473351052440016560000017187056802081284486_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      clipPath: "url(#SVGID_00000130640363040579638010000009138726624572017033_)",
      fill: "#EAEAEF"
    },
    d: " M1029.9,621.9c-0.1,5.1-0.2,10.3-0.5,15.4c0,0,0,0,0,0c-0.1,1.9-0.2,3.9-0.3,5.8c-0.1,1.7-0.2,3.4-0.3,5.1c0,0.2,0,0.5,0,0.7 c-0.1,1.7-0.2,3.4-0.3,5.1c0,0.5-0.1,1.1-0.1,1.6c-0.1,1.7-0.2,3.3-0.3,5c-0.2,2.2-0.3,4.4-0.5,6.7c-0.4,5.8-0.9,11.8-1.5,17.8 c-0.1,1-0.2,2-0.3,3c-0.6,5.9-1.2,12-1.9,18.1c-0.2,2-0.5,4.1-0.7,6.2c0,0.2,0,0.3-0.1,0.5c-0.4,3.7-0.9,7.4-1.3,11.1 c-0.1,0.8-0.2,1.5-0.3,2.3c-0.1,0.6-0.2,1.3-0.2,1.9c-0.2,1.6-0.4,3.2-0.6,4.8c-0.1,1-0.3,1.9-0.4,2.9c-0.2,1.2-0.3,2.4-0.5,3.7 c-0.3,2.1-0.6,4.1-0.9,6.2c-0.3,1.8-0.5,3.6-0.8,5.5c0,0,0,0,0,0.1c-0.1,0.8-0.2,1.7-0.4,2.5c-0.2,1.3-0.4,2.5-0.6,3.8 c0,0.3-0.1,0.5-0.1,0.8c-0.2,1.6-0.5,3.3-0.7,4.9c-0.3,2-0.6,4-0.9,6c-0.2,1.1-0.3,2.1-0.5,3.2c-0.2,1.6-0.5,3.1-0.7,4.7l-0.8,4.9 c0,0.3-0.1,0.6-0.1,0.8c-0.1,0.9-0.3,1.8-0.5,2.8c-0.3,1.9-0.6,3.8-0.9,5.6c-0.3,1.8-0.6,3.5-0.9,5.3c-0.4,2-0.7,4.1-1.1,6.1 c-0.1,0.4-0.1,0.8-0.2,1.2c-0.2,1.1-0.4,2.1-0.6,3.2c-0.2,1-0.4,2-0.6,3.1c-0.5,2.7-1,5.4-1.5,8.1c-0.4,2.1-0.8,4.2-1.2,6.3 c-0.3,1.7-0.6,3.3-1,5c-0.3,1.6-0.6,3.1-0.9,4.7c-0.3,1.3-0.5,2.6-0.8,3.9c0,0,0,0,0,0c-0.3,1.4-0.6,2.9-0.9,4.3 c-0.3,1.7-0.7,3.3-1,5c-0.3,1.5-0.6,3.1-1,4.6c0,0.2-0.1,0.3-0.1,0.5c-0.3,1.5-0.7,3.1-1,4.6c-0.4,2.1-0.9,4.1-1.3,6.1 c0,0.2-0.1,0.3-0.1,0.5c-0.5,2.2-1,4.4-1.5,6.5L-20,894.3V757c0.1-0.7,0.2-1.4,0.3-2.1c0.1-0.7,0.2-1.4,0.3-2 c0.2-1.1,0.4-2.3,0.6-3.4c0.1-0.4,0.1-0.8,0.2-1.2c0.2-0.9,0.4-1.8,0.6-2.7c0.6-2.6,1.2-5.1,1.8-7.6c0.3-1.1,0.6-2.3,0.9-3.4 c0.2-0.6,0.4-1.3,0.6-1.9c0.1-0.5,0.3-0.9,0.4-1.4c0.2-0.6,0.4-1.2,0.6-1.8c0.2-0.6,0.4-1.2,0.6-1.8c0.2-0.5,0.3-1,0.5-1.4 c0.3-0.7,0.5-1.5,0.8-2.2c6.3-2.4,12.7-5,19.1-7.8C110,672.6,230.1,589.4,292,540c17.6-14.1,30.5-25.4,36.9-32.3 c5.7-6.1,11.6-12.2,18.8-16.5c7.2-4.3,16.1-6.6,24.3-4.6c10.6,2.6,18.3,11.6,23.6,21c5.3,9.4,9.5,20.1,18.6,25.9 c2.3,1.4,4.8,2.5,7.4,3.1c5.9,1.4,12.3,0.8,17.7-1.8c1-0.5,2-1,2.9-1.7c2-1.3,4.3-3,6.5-2.1c0.6,0.3,1.1,0.7,1.6,1.2 c0.4,0.5,0.7,1,1,1.5c7,11.7,13.6,26.6,27.3,28.3c13.8,1.7,26.9-12,40.3-8.2c9.4,2.6,14.3,12.7,22.3,18.3c13,9.1,31.8-5.6,38.5-10 c12.1-8,16.6-15.4,43.3-55.3c16.3-24.3,19.4-28.7,25-35c11.4-12.9,32.6-37,45-32c13.5,5.4,4.2,40.3,23,50c3.9,2,114.6,2.2,121,0 c24.7-8.4,23.8-31.7,55-54c14.3-10.2,13.9-5.4,25-14c29.1-22.5,23-48.6,49-78c1.7-1.9,29.9-33.4,43-27 c25.2,12.4-37.5,150.6,3.3,179.2c8.8,6.2,20.3,5.7,29.7,3.7C1043.8,518.1,1030.2,603.4,1029.9,621.9z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M945,551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M975,566c-3.4,3-7.3,6.9-11,12c-7.9,11.1-10.8,22.1-12,29"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 258.5,
    className: "st12",
    width: 927,
    height: 441
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "States",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M560.2,131.4c0.6,1.2-0.2,2.5-0.4,3.9c-0.2,1.7-0.6,3.4-1,5.1c-0.3,1.4,0.1,2.6,0.6,3.9 c0.4,1.3,0.7,2.7,1.1,4c0.2,0.7,0.5,1.4,0.9,2.1c0.5,0.8,0.5,1.4-0.2,2c-0.6,0.5-1,1.2-1.7,1.6c-0.4,0.2-1,0.3-1.4,0.1 c-0.7-0.2-1.3-0.7-1.9-1.1c-1.1-0.7-2.3-0.9-3.5-0.8c-1.3,0.1-2.6,0.1-3.6-0.9c-0.9-0.8-2.1-0.9-3.2-1.2c-1.5-0.5-3-0.9-4.5-1.5 c-1.4-0.6-2-2.1-2.4-3.5c-0.4-1.2-0.5-2.4-1.9-3.1c-0.3-0.2-0.5-0.8-0.6-1.2c-0.1-0.6,0-1.2-0.1-1.9c0-0.3-0.1-0.6-0.3-0.7 c-0.8-0.6-0.7-1.4-0.5-2.3c0.3-1,0.1-1.2-0.9-1.7c-0.5-0.2-1.1-0.6-1.4-1.1c-0.8-0.9-1.4-1.9-2.1-2.9c-0.8-1.2-1.6-2.4-3.1-2.9 c-0.7-0.3-0.9-0.9-1.1-1.6c-0.2-1-0.7-1.9-1.1-2.8c-0.7-1.8-1.4-3.6-2.3-5.3c-0.4-0.9-1-1.8-1.7-2.6c-1.1-1.1-2.3-2.1-3.4-3.1 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.7-1.6-2.2-1.6-3.7-1.6c-1.5,0-3-0.2-4.6-0.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.7-1.6-0.5-2.4-0.1 c-1.2,0.6-2.6,1.1-2.8,2.6c-0.4,2.5-2.3,4.2-3.5,6.2c-0.5,0.8-1.1,1-2,0.5c-1.4-0.7-3-1.3-4.4-1.9c-0.3-0.1-0.6-0.3-0.8-0.5 c-0.7-0.9-1.6-1.3-2.6-1.7c-0.8-0.3-1.6-0.9-2.2-1.5c-1.3-1.3-2.5-2.6-3.7-4c-0.9-1.1-1.2-2.4-1.1-3.8c0.1-1.5-0.3-2.8-1.2-4 c-0.7-1-0.8-2.5-2-3.3c-0.4-0.3-0.9-0.7-1.3-0.9c-1-0.3-1.9-0.8-2.6-1.7c-0.9-1.1-2-2-3-3c-0.3-0.3-0.6-0.5-0.7-0.8 c-0.6-1.3-1.6-1.9-2.8-2.4c-0.5-0.2-0.9-1-1.1-1.6c-0.4-1.1-1-1.9-2.1-2.2c-0.4-0.1-0.7-0.7-0.9-1.1c-0.2-0.6-0.3-1.3-0.4-1.9 c-0.1-1.1,0.2-1.5,1.3-1.5c4,0.1,8.1,0.1,12.1,0.2c4.4,0.1,8.9,0.2,13.3,0.3c2.2,0.1,4.4,0.2,6.6,0.3c0.8,0,1.1-0.2,1.1-1.1 c0.3-9.6,0.5-19.2,0.8-28.7c0.2-5.9,0.3-11.8,0.4-17.7c0-1.5,0.4-1.8,1.9-1.8c8.9-0.1,17.8-0.2,26.6-0.2c1.4,0,1.7,0.3,1.7,1.7 c-0.1,6.7-0.1,13.4-0.3,20c-0.1,1.8,1,2.5,2.1,3.3c0.3,0.2,1,0.1,1.4-0.1c1.3-0.9,2.4-0.3,3.5,0.3c0.2,0.1,0.4,0.6,0.4,0.9 c0,0.8,0.3,1.1,1.1,1.2c1.5,0.2,2.9,0.5,4.4,0.8c0.1,0,0.3,0,0.4,0c1.8-0.8,3.4-0.5,4.7,1c0.3,0.3,0.6,0.6,0.9,0.9 c0.2,0.1,0.6,0.3,0.7,0.2c1.1-0.7,2.1-0.1,3.2,0c0.3,0,0.7,0.4,0.8,0.7c0.5,1,1.5,1.1,2.4,1.1c0.2,0,0.5-0.4,0.6-0.7 c0.2-0.6,0.3-1.4,1.1-1.6c0.8-0.2,1.5,0,2.1,0.8c0.2,0.3,0.6,0.5,1,0.6c1.1,0.3,2.3,0.5,3.4,0.7c0.2,0,0.7-0.3,0.8-0.5 c0.2-0.8,0.7-1.1,1.4-1.2c0.4-0.1,0.9-0.1,1.3-0.1c1,0,1.9,0.1,2.7-0.6c0.3-0.3,1.2,0,1.8,0.3c0.6,0.3,1,0.3,1.4-0.2 c0.7-0.8,2.2-0.8,2.9-0.1c1.4,1.6,3.5,2.1,5.3,3c0.3,0.1,0.8,0.1,1.1-0.1c1.6-0.7,3.3,0.2,3.4,1.9c0.2,2.3,0.3,4.6,0.5,6.8 c0.2,2.1,0.5,4.3,0.9,6.4c0.2,0.9,0.8,1.6,1.2,2.4c0.2,0.4,0.5,0.9,0.6,1.3c0.1,1.5,1.1,2.5,2,3.6c0.4,0.5,0.7,1.3,0.8,2 c0.2,1.8,0.4,3.6,0.4,5.4c0,0.7-0.4,1.4-0.6,2.1c-0.1,0.5-0.1,1,0,1.4c0,0.2,0.2,0.4,0.2,0.6c-0.2,2.2-0.5,4.4-0.8,6.6 c-0.1,0.6-0.1,1.3-0.1,1.9c0,0.7-0.3,1.2-0.9,1.5c-1.4,0.6-2.8,1.3-4.2,1.8c-1.8,0.7-3.1,1.8-4.4,3.1c-1.5,1.5-2.9,3-4.6,4.3 c-2.1,1.7-4.3,3.2-6.6,4.7c-2.3,1.6-4.8,3-7.1,4.5c-0.3,0.2-0.6,0.5-0.9,0.6c-1.3,0.2-1.8,1.2-2.5,2.1 C561.6,130.2,560.9,130.7,560.2,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M748.7,117.3c-3-0.1-6-1-9.1-1.1c-1,0-2.3-0.4-2.7-1.6c-0.4-1.3,1-1.4,1.7-2c2.3-1.9,2.3-4.6,2.1-7.1 c-0.2-2.4,0.4-4,2.3-5.3c0.6-0.4,1.4-1,1.5-1.6c0.8-3,3.2-5,4.7-7.3c1.5-2.5,5.6-5.5,2.9-9.7c-0.1-0.2-0.1-0.5,0-0.6 c1.3-2.2,2.5-4.4,4-6.4c1.1-1.4,3-1.3,4.6-1.3c9.3,0,18.5-0.2,28.1,0.5c0.3-1.5-1-3.4,1.2-4.5c1.7-0.8,3.2,0,4.8,0.2 c1.1,0.1,2.2,0.5,3.3,0.4c21.2-0.5,42.4,1,63.6,0.8c16.1-0.2,32.2-0.2,48.4-0.8c6.9-0.3,13.8-1.1,20.6-1.7c1.8-0.2,3.5,0.2,5.2,0.6 v2.6c-2.2,1.4-0.9,3.7-1.5,5.5c-0.3,1,0,2.3-1.6,2.3c-2.5,0.1-3.7,1.6-4.5,3.6c-0.8,2.2-2.2,3.2-4.8,2.8c-2.4-0.4-4.4,0.2-6,2.4 c-1.3,1.8-2.8,3.9-5.4,1.2c-1-1-1.6,0.3-2,0.9c-3.7,5.8-10.7,7.2-15.7,11.2c-1.3,1-3.2,0.7-4.8,0.7c-2.9,0-4.9,1.3-5.6,4.1 c-0.7,2.6-2.2,4.6-5,5c-1.7,0.2-1.4,1.3-1.6,2.3c-0.7,4.2-1.4,4.8-5.8,4.8C867,118.1,759.7,117.5,748.7,117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.4,87c-0.6-0.1-1.1-0.2-1.6-0.3c-0.4-0.1-0.8-0.3-1.1-0.7c-0.2-0.3-0.5-0.6-0.8-0.9 c-0.2-0.2-0.4-0.4-0.8-0.1c-0.1,0.1-0.3,0-0.5,0c0.2-0.7,0.4-1.4,0.1-2.1c-0.1-0.3,0.1-0.8,0-1.1c-0.2-0.6-0.6-1.1-0.8-1.7 c0-0.1-0.1-0.1-0.2-0.2c-0.3-0.7-1-1.1-1.6-1.5c-0.7-0.5-1.2-1.3-1.7-2c-0.5-0.7-1.1-1.5-1.6-2.2c-0.3-0.4-0.6-0.7-0.8-1.2 c-0.1-0.3,0-0.7,0.1-1.1c0.3-0.7,0.3-1.4-0.3-1.9c-0.4-0.5-0.8-1-0.6-1.6c0.2-1,0.2-2.1,0.5-3.2c0.1-0.3-0.1-0.6-0.1-1 c0-0.2-0.2-0.5-0.1-0.7c0.1-1.1-0.5-1.9-1-2.7c-0.5-0.7-0.9-1.5-1.4-2.2c-0.3-0.4-0.6-0.7-1-0.9c-0.6-0.4-1.2-0.8-1.5-1.5 c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.7-0.2-1.4-0.2-2.1c0-0.4,0.2-0.9,0.4-1.3c0.2-0.4,0.4-0.8,0.6-1.2c0.1-0.3,0.4-0.5,0.5-0.7 c0.1-0.3,0.2-0.6,0.3-0.9c0.2,0,0.5,0,0.7-0.1c0.4-1.2,0.2-2.5,0.2-3.7c0-0.3,0-0.5,0.3-0.7c0.3-0.2,0.5-0.8,0.5-1.2 c0.1-0.9,0.1-1.9,0.2-2.8c0.1-1.2-0.1-2.3-0.5-3.3c-0.1-0.2-0.3-0.5-0.6-0.6c-0.3-0.2-0.4-0.4-0.2-0.7c0.3-0.6,0.3-1.2,0.3-1.9 c0-0.2,0.2-0.4,0.3-0.7c0.1-0.1,0.2-0.2,0.2-0.3c0-0.7,0.5-0.8,1.1-0.7c1.5,0,2.9,0,4.4,0c2.1,0,4.2,0.1,6.3,0.2 c2.3,0.1,4.7,0.1,7,0.2c1.6,0,3.3,0,4.9,0.2c3.6,0.3,7.1,0,10.7,0.2c1.5,0,3,0.1,4.4,0.2c0.4,0,0.7,0.2,0.7,0.7 c0,8.4,0,16.8,0,25.2c0,2.7-0.1,5.3-0.2,8c0,1.1-0.1,2.3-0.2,3.4c0,0.5,0.3,0.8,0.6,1.1c0.2,0.2,0.5,0.4,0.8,0.6 c1.1,1,2.2,2.1,3.3,3.1c0.7,0.6,1.4,1.2,2,1.9c1,0.9,2,1.8,3,2.8c1,1,2.1,2,3.1,2.9c1.1,1,2.2,2,3.4,3c1.1,1,2.2,1.9,3.2,2.9 c1.4,1.3,2.8,2.6,4.2,3.8c0.7,0.7,1.5,1.3,2.2,2c1,0.9,2,1.8,3,2.8c1,0.9,2,1.8,3,2.8c1.1,1,2.1,2,3.1,3c1.2,1.1,2.5,2.2,3.7,3.3 c1.2,1.1,2.4,2.2,3.6,3.2c1.4,1.3,2.8,2.5,4.2,3.8c0.8,0.7,1.5,1.4,2.3,2.1c1.5,1.4,3.1,2.8,4.6,4.2c0.2,0.2,0.3,0.5,0.3,0.8 c0.1,0.9,0.5,1.6,1.2,2.2c0.3,0.3,0.5,0.6,0.7,0.9c0.5,0.9,0.9,1.8,1.4,2.7c0.4,0.7,1,1,1.7,1.3c0.7,0.4,0.9,0.6,0.7,1.2 c-0.1,0.3-0.3,0.7-0.5,1c-0.7,0.7-1.4,1.3-2.3,1.8c-0.6,0.3-1.1,0.9-1,1.7c0.1,0.9,0.2,1.8,0.2,2.7c0,1.3-0.4,2.5-1.4,3.4 c-0.5,0.5-0.6,1.1-0.3,1.7c0.3,0.8,0.5,1.6,0.2,2.5c0,0.1,0.4,0.4,0.6,0.6c0.2,0.1,0.5,0,0.7,0.1c0.7,0.3,0.8,0.5,0.9,1.2 c0.1,1.1-0.2,2.1-1,2.9c-0.2,0.2-0.6,0.4-1,0.5c-0.6,0.1-1.2,0.1-1.8,0.2c-1.2,0.1-2.5,0.2-3.7,0.4c-1,0.1-2.1,0.3-3.1,0.5 c-1.2,0.2-2.3,0.4-3.5,0.5c-1.3,0.2-2.5,0.3-3.8,0.5c-1.3,0.2-2.5,0.3-3.8,0.5c-0.9,0.1-1.8,0.2-2.8,0.4c-0.7,0.1-1.4,0.4-2.1,0.5 c-0.6,0.1-1.2,0-1.8,0c-0.1-0.3-0.2-0.6-0.2-1c0-0.1,0-0.3,0.1-0.3c0.5-0.2,0.2-0.5,0-0.7c-0.3-0.3-0.5-0.7-1.1-0.5 c-0.1,0.2-0.1,0.4-0.2,0.7c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.4,0-0.6c-0.1-0.4-0.1-0.9-0.2-1.3c0-0.2,0-0.4,0-0.5 c0.6-0.6,0.3-1.3,0.1-1.9c-0.4-0.9-1-1.6-1.5-2.4c-0.5-0.6-1-1.2-1.5-1.7c-0.9-0.8-1.8-1.6-2.7-2.3c-0.1,0-0.1-0.1-0.2-0.1 c-1,0-1.4-0.8-2-1.4c-0.8-0.7-1.2-0.8-2-0.2c-0.1,0.1-0.2,0.1-0.2,0.1c-0.5-0.1-1-0.2-1.5-0.4c-0.1-0.1-0.3-0.4-0.1-0.7 c0.4-0.5,0.3-1.1-0.2-1.6c-0.1-0.1-0.1-0.2-0.1-0.3c-0.2-0.8-0.9-1-1.7-0.9c-1.1,0.2-2.3,0.5-3.3-0.3c-0.1-0.1-0.2,0-0.4-0.1 c-0.7-0.4-1.5-0.6-2.2-1.1c-0.3-0.2-0.3-0.8-0.6-1.2c-0.4-0.8-1.1-1.3-1.9-1.6c-0.5-0.2-1-0.3-1.5-0.3c-0.2,0-0.6,0.2-0.8,0.1 c-0.7-0.2-1.5-0.1-2.2-0.2c-0.5,0-0.9-0.4-1.4-0.5c-0.8-0.1-1.6,0-2.4,0c-0.7,0-1.5,0.3-2.1-0.4c-0.3-0.4-0.9-0.6-1.3-0.9 c-0.2-0.1-0.3-0.2-0.5-0.4c0.1-0.2,0.2-0.5,0.3-0.7c0.2-0.3,0.2-0.6-0.1-0.9c-0.1-0.1-0.1-0.5,0-0.7c0.3-0.4,0.2-0.7,0-1.2 c-0.2-0.4-0.4-1-0.3-1.4c0.1-0.8,0.4-1.5,0-2.2c0-0.1,0-0.2,0-0.1c-0.8-0.3-1.5-0.5-2.3-0.8c0.2-0.4,0.3-0.9,0.5-1.3 c0.3-0.6-0.1-1.4-0.8-1.4c-0.4,0-0.7-0.2-0.9-0.6c-0.3-0.5-0.7-1.1-1.1-1.6c-0.3-0.4-0.6-0.6-1.1-0.2c-0.2-0.6-0.4-1.2-0.6-1.7 c-0.1-0.3-0.3-0.7-0.6-0.9c-0.7-0.5-0.8-1.3-1.1-1.9c-0.1-0.2-0.3-0.4-0.4-0.5c-0.2-0.2-0.4-0.3-0.5-0.6c-0.5-1.1-1.4-1.8-2.4-2.5 c-0.3-0.2-0.5-0.4-0.4-0.8c0.1-0.8-0.1-1.6-0.6-2.3c-0.5-0.8-0.1-1.4,0.1-2c0.1-0.3,0.4-0.6,0.5-0.8c0.2,0.1,0.4,0.2,0.7,0.4 c0.1-1.4,0.1-2.6-0.9-3.5c-1,0.8-1.4,0.6-2.3,0.1c-0.6-0.3-1.1-0.6-1.6-1.1c-0.4-0.4-0.5-0.9-0.7-1.4c-0.6-1.1-0.2-2.3-0.4-3.5 c0-0.4-0.3-0.8-0.5-1.1c-0.4-0.4-0.3-0.8-0.2-1.2C179.2,89,179.3,88,179.4,87z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 151.8164 202.288)",
    className: "st1 st14 st15 st16"
  }, "California"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 493.5938 202.288)",
    className: "st1 st14 st15 st16"
  }, "Texas"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 771.7612 202.288)",
    className: "st1 st14 st15 st16"
  }, "Tennessee"))), /*#__PURE__*/React.createElement("g", {
    id: "Tenn",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tennessee",
    className: "st1"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M866.8,386.5c0-9.9-10.5-17.8-23.4-17.8s-23.4,8-23.4,17.8H866.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M820.1,386.5c0-4.9-5.2-8.9-11.7-8.9c-6.5,0-11.7,4-11.7,8.9H820.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M857.7,355c0-9.9,10.5-17.8,23.4-17.8c12.9,0,23.4,8,23.4,17.8H857.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M904.4,355c0-4.9,5.2-8.9,11.7-8.9s11.7,4,11.7,8.9H904.4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 705.7,
    y1: 410.6,
    x2: 720.3,
    y2: 491.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 721.3,
    y1: 410.6,
    x2: 735.9,
    y2: 491.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 737.5,
    y1: 410.6,
    x2: 752,
    y2: 491.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 753.3,
    y1: 410.6,
    x2: 767.9,
    y2: 491.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 769.3,
    y1: 410.5,
    x2: 783.8,
    y2: 491.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 785.1,
    y1: 410.5,
    x2: 799.6,
    y2: 491.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M720.3,492.7c0-23.8,19.3-43.1,43.1-43.1c23.8,0,43.1,19.3,43.1,43.1l-38.2,0L720.3,492.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M948.5,317c0-17.9-19.1-32.5-42.6-32.5S863.3,299,863.3,317H948.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M863.5,317c0-9-9.5-16.2-21.3-16.2s-21.3,7.3-21.3,16.2H863.5z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M745.7,360.1c-2-6.1-5.6-19.8-0.5-34.6c10-29.1,49.9-38.9,50.8-37.3c0.6,1.1-15.5,7.2-31,25.5 c-11.3,13.4-18.4,26.3-21.7,36.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M745.7,360.5c-0.2,0-0.4-0.1-0.4-0.3c-2.8-8.4-5.2-21.3-0.5-34.9c8.9-25.9,41.4-36.9,49.8-37.7 c1.1-0.1,1.6,0,1.8,0.4c0.4,0.7-0.4,1.2-3.3,2.9c-5.4,3.3-16.7,10-27.7,23.1c-10.2,12.1-17.9,25.1-21.6,36.5 c0.6,3.6,1.4,6.8,2.4,9.5c0.1,0.2,0,0.5-0.3,0.6C745.8,360.5,745.8,360.5,745.7,360.5z M795.2,288.5c-1.8,0-8,1.3-15.8,4.7 c-10,4.3-27.6,14.3-33.8,32.4c-2.8,8.2-3,16.1-2.1,22.9c3.9-11.1,11.4-23.4,21.2-35.1c11.1-13.2,22.5-20,27.9-23.3 C793.7,289.5,794.7,288.8,795.2,288.5C795.3,288.5,795.3,288.5,795.2,288.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M745.5,360.3c-5.8-2.8-19-7.9-34.3-4.6c-30.1,6.4-44.5,44.9-43,46c1,0.7,9-14.5,29-27.7 c14.7-9.6,28.3-15.1,39-17.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M668.2,402.1c-0.1,0-0.2,0-0.4-0.1c-0.3-0.2-0.4-0.8-0.1-1.9c1.8-8.2,16.6-39.2,43.4-44.9 c14.1-3,26.6,0.9,34.6,4.7c0.2,0.1,0.3,0.4,0.2,0.6c-0.1,0.2-0.4,0.3-0.6,0.2c-2.6-1.2-5.7-2.5-9.2-3.5 c-11.6,2.3-25.4,8.3-38.7,17.1c-14.3,9.4-22.4,19.8-26.3,24.8C669.5,401.2,668.8,402.1,668.2,402.1z M721.3,355 c-3.2,0-6.6,0.3-10,1c-18.7,4-30.7,20.3-36.2,29.7c-4.3,7.4-6.4,13.4-6.6,15.1c0.4-0.5,1.2-1.4,2-2.4c3.9-5,12.1-15.5,26.5-25 c12.8-8.4,25.9-14.3,37.3-16.9C730.3,355.7,725.9,355,721.3,355z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M892.8,480.8c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C896.4,482.1,894.2,482.8,892.8,480.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M894.6,482.2c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2v0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.1C898.1,480.8,896.1,482.2,894.6,482.2z  M893.1,480.6c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9 c-1.3-0.1-3.2,1.2-6.3,4.4C893.8,474.2,891.6,478.4,893.1,480.6L893.1,480.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M892.8,496.8c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C896.4,498.1,894.2,498.8,892.8,496.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M894.6,498.2c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2c0,0,0,0,0,0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.1C898.1,496.8,896.1,498.2,894.6,498.2z  M893.1,496.6c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9 c-1.3-0.1-3.2,1.2-6.3,4.4C893.8,490.2,891.6,494.4,893.1,496.6L893.1,496.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M892.8,463.8c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C896.4,465,894.2,465.8,892.8,463.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M894.6,465.2c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2c0,0,0,0,0,0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.2C898.1,463.8,896.1,465.2,894.6,465.2z  M893.1,463.6c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9 c-1.3-0.1-3.2,1.2-6.3,4.4C893.8,457.2,891.6,461.4,893.1,463.6L893.1,463.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M892.8,446.7c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C896.4,448,894.2,448.7,892.8,446.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M894.6,448.1c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2l0,0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.1C898.1,446.7,896.1,448.1,894.6,448.1z  M905.9,429.8c-1.3,0-3.2,1.4-6.2,4.4c-5.9,5.9-8.1,10.1-6.6,12.3l0,0c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3 c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9C906,429.8,905.9,429.8,905.9,429.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st23",
    points: "891.8,465.3 891.8,423 891.8,634.4  "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M740.8,565.8c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C744.4,567.1,742.2,567.8,740.8,565.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M742.6,567.2c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2v0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.1C746.1,565.8,744.1,567.2,742.6,567.2z  M741.1,565.6c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9 c-1.3-0.1-3.2,1.2-6.3,4.4C741.8,559.2,739.6,563.4,741.1,565.6L741.1,565.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M740.8,581.8c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C744.4,583.1,742.2,583.8,740.8,581.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M742.6,583.2c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2c0,0,0,0,0,0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.1C746.1,581.8,744.1,583.2,742.6,583.2z  M741.1,581.6c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9 c-1.3-0.1-3.2,1.2-6.3,4.4C741.8,575.2,739.6,579.4,741.1,581.6L741.1,581.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M740.8,548.8c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C744.4,550,742.2,550.8,740.8,548.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M742.6,550.2c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2c0,0,0,0,0,0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.2C746.1,548.8,744.1,550.2,742.6,550.2z  M741.1,548.6c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9 c-1.3-0.1-3.2,1.2-6.3,4.4C741.8,542.2,739.6,546.4,741.1,548.6L741.1,548.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M740.8,531.7c-1.8-2.6,1-7.1,6.6-12.8c4.6-4.7,6.8-5.4,8.2-3.4c1.8,2.6-1.1,7.1-6.7,12.7 C744.4,533,742.2,533.7,740.8,531.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M742.6,533.1c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.5-1.8-1.2l0,0c-1.8-2.6,0.4-6.9,6.7-13.2 c3.3-3.3,5.3-4.7,6.9-4.5c0.7,0.1,1.3,0.5,1.8,1.2c1.7,2.5-0.5,6.8-6.7,13.1C746.1,531.7,744.1,533.1,742.6,533.1z  M753.9,514.8c-1.3,0-3.2,1.4-6.2,4.4c-5.9,5.9-8.1,10.1-6.6,12.3l0,0c0.4,0.6,0.8,0.9,1.3,0.9c1.3,0.1,3.2-1.2,6.3-4.3 c5.9-6,8.2-10.1,6.6-12.3c-0.4-0.6-0.8-0.9-1.4-0.9C754,514.8,753.9,514.8,753.9,514.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st23",
    points: "739.8,550.3 739.8,508 739.8,649.4  "
  }))))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M946.9,598c-5.3,2-18.7-8.5-21.3-19.8c-2.6-11.3,10.4-11.5,0.5-31.1s-17.7-28.2,1.6-50.9 c19.3-22.6,11.5-40.2,31.5-42.1s21.6,22.8,12.2,41.5c-9.4,18.7-6.9,23.8,11,26.4c17.9,2.7-7.5,27-9.8,33.1 c-2.4,6.2,3.6,20.4-1.9,28.4S952.3,596.1,946.9,598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016052648500971238640000003762665582617478528_",
    x: 915.8,
    y: 453.8,
    width: 73.1,
    height: 202.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061465670856860230210000002711399064745026455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016052648500971238640000003762665582617478528_",
    style: {
      overflow: "visible"
    }
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M961.8,471.4c-5.6,19.7-10.7,42.4-13.9,68c-5.6,45.4-3.5,85,0.7,115.8c-3.9-49.7-7.9-99.4-11.8-149.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M954.9,481.1"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M899.8,699.8c-11.3,0.4-21.6-4.2-32.3-4.4c-1.5,0-3.3-0.2-4.3-1.4c-1.4-1.8-0.1-4.4,1.5-6 c5.6-5.5,14.8-6.9,21.8-3.3c-2.5-0.8-3.9-3.4-5.6-5.4c-4.9-5.9-9-12.5-12.2-19.5c-1-2.3-1.9-5.1-0.5-7.2c1.1-1.5,3.1-2.1,4.9-2.2 c1.3-0.1,2.6,0,3.8,0.4c1.2,0.4,2.3,1.2,3.4,2c5.8,4.7,10.3,10.9,12.8,17.9c-5.8-15.5-9.6-30.1-10.9-46.6 c-0.7-9-0.6-18.7,4.1-26.4c2.3-3.9,5.8-7.2,9.8-9.4c3.5-1.9,7.6-2.9,11.4-1.8c6.7,1.9,10.1,9.2,11.4,16 c4.1,21.3-4.1,43-13.1,62.8c-0.5-0.4,0.1-0.2,0.6-0.6c7.8-7.6,18.2-12.5,29.1-13.7c3.1-0.3,6.9,0.1,8,3.1 c0.4,1.2,0.2,2.6-0.3,3.9c-1.5,4-4.9,7-8.5,9.3c-8.3,5.3-18.7,8.1-24.4,16.1c1.8-2.8,6.5-4,9.6-5.1c6.2-2.1,12.7-3.1,19.2-2.8 c1.4,0.1,2.9,0.3,3.8,1.4c0.6,0.9,0.6,2.1,0.3,3.2c-1.3,4.7-6.2,7.4-10.7,9.3C922.3,693.7,908.8,699.3,899.8,699.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 903.9,
    y1: 601.8,
    x2: 899.3,
    y2: 699.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 900.3,
    y1: 679.5,
    x2: 933.1,
    y2: 657.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 899.7,
    y1: 690.2,
    x2: 924.5,
    y2: 683.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 899.8,
    y1: 684.4,
    x2: 879.9,
    y2: 664.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 899.7,
    y1: 692.1,
    x2: 879.6,
    y2: 688.7
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 808.8,
    y: 616.5,
    className: "st27",
    width: 5.3,
    height: 82.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M810.6,629.4c6.2-0.8,33.7-8.2,41.8-25.8c9.7-21.4-1.3-23.3-2.1-29.2c-1-7.2,7.7-13.5,3.5-26.8 c-1.9-6-12-9.9-12.9-19.3c-0.9-9.1,8.1-14.4,6.5-27.1c-1.4-10.9-11.1-12.8-13.4-19.9c-1.7-5.4,2.1-11.1,0-16.4 c-4.4-10.8-14.9-2.2-20.3,5.2c-6.1,8.4-3.9,15.4-6.2,20.6c-2.5,5.7-18.3,13.4-22.8,21.5c-6.1,10.8,4.4,16.9,1.4,23.9 c-2.7,6.1-18.4,16.2-19.4,25.6c-0.8,7.7,10.2,14.2,10.1,21.9c0,3.9-4.8,9.5-1.7,17.6C781.5,618.2,806.3,628.3,810.6,629.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M815.7,527.2c-0.5,0-0.9,0.4-1,0.9c-3.4,33.4-4.6,66-4.2,98.1c0,0.6,0.4,1,1,1c0.6,0,1-0.5,1-1 c-0.4-32,0.8-64.6,4.2-97.9C816.8,527.7,816.3,527.2,815.7,527.2z M820.7,488.5c-0.5,0-0.8,0.4-0.9,0.8 c-1.4,9.1-2.6,18.1-3.7,27.1c-0.1,0.5,0.3,1,0.8,1.1c0.5,0.1,1-0.3,1.1-0.9c1.1-9,2.3-18,3.7-27.1 C821.8,489,821.3,488.5,820.7,488.5z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M723.9,701.4c-0.1,0-0.2,0-0.3,0c-1.1,0-2.2,0-3.3-0.1c-0.9,0-1.8,0-2.6-0.1h0c-3.6-0.1-7.1-0.3-10.7-0.5 c-5.9-7.3-12.8-14-18.8-21.3c-6.8-8.3-12.7-17.8-14.1-28.4c-0.3-2.2-0.3-4.7,1.4-6.2c1.4-1.2,3.5-1.3,5.3-1 c9.2,1.3,17.1,7.6,23.1,14.7c6.2,7.3,10.9,15.7,14.4,24.5c2.2,5.5,4,11.2,5.4,17C723.7,700.6,723.8,701,723.9,701.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M717.6,701.3L717.6,701.3c-6.3-13.5-16.7-31.6-31.7-42.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M737.3,650c0,15.1-1.6,30.4-4.3,45.5c-0.2,1.1-0.4,2.2-0.6,3.3c-0.1,0.6-0.3,1.5-0.4,2.6c-0.5,0-1,0-1.4,0 c-1.9,0-3.7,0-5.6,0c-0.4,0-0.7,0-1.1,0c0,0.1,0,0.1,0,0.2c0-0.1,0-0.1,0-0.2c-0.1,0-0.2,0-0.3,0c-1.1,0-2.2,0-3.3-0.1 c-0.3-5-0.8-10-1.5-14.8c-0.2-1.1-0.3-2.2-0.5-3.3c-2.3-14.2-5.9-27.7-8.4-41.9c-2.6-15.2-3.8-31.8-0.3-47.8 c0.7-3.3,1.9-6.9,4.2-8.2c1.9-1.1,3.9-0.1,5.6,1.2c8.3,6.4,12.8,19.3,15.3,32.5C736.5,629,737.3,639.4,737.3,650z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M723.5,701.4c0-0.4,0-0.8,0.1-1.2c1.4-28.9,3-82.1-3.8-96.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M788.1,604c-2.3,16.6-9.7,32-18.1,45.5c-8.4,13.6-18,25.9-26.1,39.8c-0.8,1.4-1.6,2.9-2.4,4.3 c-1.3,2.4-2.6,4.9-3.8,7.5c-0.8,0-1.6,0.1-2.4,0.1c-1,0-2.1,0.1-3.1,0.1c-0.5,0-1,0-1.4,0c-1.9,0-3.7,0-5.6,0c-0.4,0-0.7,0-1.1,0 c0.5-2.5,0.9-4.4,1.1-5.5c2.8-15.6,6.7-31.2,12.3-45.9c4.1-11,9.2-21.4,15.3-31c7.5-11.7,17-22.3,28-25.3c2.2-0.6,4.7-0.8,6.2,1 C788.7,596.7,788.6,600.6,788.1,604z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st33",
    points: "762.2,625.6 733.1,695.5 730.6,701.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M797.3,669.5c-6.4,9.4-15.5,16.5-24.7,22.2c-4.6,2.9-9.4,5.5-14.1,8.1c-3.4,0.3-6.9,0.6-10.3,0.9 c-3.5,0.2-7,0.4-10.6,0.5c-0.8,0-1.6,0.1-2.4,0.1c2-2.6,4.1-5.1,6.2-7.5c8.9-10.1,18.8-19.2,29.8-25.9c8.1-4.9,17.1-8.4,24.6-7 c1.5,0.3,3.1,0.9,3.5,2.5C799.9,665.2,798.6,667.6,797.3,669.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st33",
    x1: 774.9,
    y1: 677.5,
    x2: 748.2,
    y2: 700.7
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M917.8,656.1c4.8,17.1,14.2,31.4,29.2,42.4h15.2C956.3,676.5,939.3,664.3,917.8,656.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M942.5,624.8c-0.8,28.2,4.2,53.4,18.6,73.7h8.8C971.5,667.8,962.9,642.9,942.5,624.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M950.7,646.7c-0.2,0-0.4,0.3-0.3,0.5c6.7,17.5,10.3,32.9,14.5,51c0,0.2,0.2,0.3,0.4,0.3 c0.2,0,0.3-0.2,0.3-0.4c-4.2-18-7.8-33.5-14.5-51.1C951,646.8,950.8,646.7,950.7,646.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M978.7,637c-8.2,18.9-16.2,37.9-13.2,61.5h8.4C988.7,678.8,984.3,656.8,978.7,637z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M976.9,661.8c-0.2,0-0.3,0.1-0.4,0.3c-1.4,14.4-4.2,23.7-7.5,35.8c-0.1,0.2,0.1,0.4,0.2,0.5 c0.2,0.1,0.4-0.1,0.4-0.3c3.3-12.2,6.2-21.5,7.6-36C977.3,662,977.1,661.8,976.9,661.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M933.1,672.7c-0.3,0-0.5,0.4-0.2,0.6c9.8,8.9,15.6,15.5,22.7,24.9c0.3,0.4,0.9-0.1,0.6-0.4 c-7.2-9.4-13-16.1-22.8-25C933.3,672.7,933.2,672.7,933.1,672.7z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st37",
    x1: 837.3,
    y1: 663.1,
    x2: 837.3,
    y2: 699.1
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M889.4,527.8c-14.3-0.4-26.3,10.8-26.7,25.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M862.7,553.3c0.2,0,0.3-0.1,0.3-0.3c0.4-14.1,12.3-25.3,26.4-24.9c0.2,0,0.3-0.1,0.3-0.3 c0-0.2-0.1-0.3-0.3-0.3c-14.5-0.4-26.6,11-27,25.5C862.3,553.1,862.5,553.3,862.7,553.3C862.7,553.3,862.7,553.3,862.7,553.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 862.7,
    y1: 553,
    x2: 860.6,
    y2: 698.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M860.6,698.9c0.2,0,0.3-0.1,0.3-0.3L863,553c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3l-2.1,145.7 C860.3,698.8,860.4,698.9,860.6,698.9C860.6,698.9,860.6,698.9,860.6,698.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M835.9,527.8c14.3-0.4,26.3,10.8,26.7,25.2L835.9,527.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M862.4,553.2L835.7,528c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.2-0.2,0.3-0.2c14.5-0.4,26.6,11,27,25.5 c0,0.1-0.1,0.2-0.2,0.3c0,0-0.1,0-0.1,0C862.6,553.3,862.5,553.2,862.4,553.2z M836.7,528.1l25.6,24.1 C861.5,538.7,850.3,528.1,836.7,528.1C836.7,528.1,836.7,528.1,836.7,528.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M862.7,553.3c0.1,0,0.2,0,0.2-0.1l26.7-25.2c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0l-26.7,25.2 c-0.1,0.1-0.1,0.3,0,0.4C862.5,553.2,862.6,553.3,862.7,553.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M884.3,550.4c-14.2,2.1-24,15.2-22,29.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M862.3,580.2C862.3,580.2,862.3,580.2,862.3,580.2c0.2,0,0.3-0.2,0.3-0.4c-2-14,7.7-27,21.7-29.1 c0.2,0,0.3-0.2,0.3-0.4c0-0.2-0.2-0.3-0.4-0.3c-14.3,2.1-24.3,15.4-22.2,29.8C862,580.1,862.1,580.2,862.3,580.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M862.3,579.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st38",
    x1: 862.3,
    y1: 579.9,
    x2: 884.3,
    y2: 550.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M862.3,580.2c0.1,0,0.2,0,0.2-0.1l22-29.4c0.1-0.1,0.1-0.3-0.1-0.4c-0.1-0.1-0.3-0.1-0.4,0.1l-22,29.4 c-0.1,0.1-0.1,0.3,0.1,0.4C862.2,580.1,862.2,580.2,862.3,580.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M883.7,573c-14.2,2.1-24,15.2-22,29.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M861.7,602.8C861.7,602.8,861.7,602.8,861.7,602.8c0.2,0,0.3-0.2,0.3-0.4c-2-14,7.7-27,21.7-29.1 c0.2,0,0.3-0.2,0.3-0.4c0-0.2-0.2-0.3-0.4-0.3c-14.3,2.1-24.3,15.4-22.2,29.8C861.4,602.7,861.5,602.8,861.7,602.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M861.7,602.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st38",
    x1: 861.7,
    y1: 602.5,
    x2: 883.7,
    y2: 573
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M861.7,602.8c0.1,0,0.2,0,0.2-0.1l22-29.4c0.1-0.1,0.1-0.3-0.1-0.4c-0.1-0.1-0.3-0.1-0.4,0.1l-22,29.4 c-0.1,0.1-0.1,0.3,0.1,0.4C861.6,602.8,861.6,602.8,861.7,602.8z"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M864.3,415c-1.2-0.7-14.6-8.8-14.6-8.8l8.4,20.4L864.3,415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M858.1,427C858.1,427,858.1,427,858.1,427c-0.1,0-0.2-0.1-0.3-0.2l-8.4-20.4c-0.1-0.1,0-0.3,0.1-0.4 c0.1-0.1,0.2-0.1,0.4,0c0,0,13.4,8.1,14.6,8.8c0.1,0.1,0.2,0.3,0.1,0.4l-6.2,11.6C858.3,426.9,858.2,427,858.1,427z M850.3,407 l7.8,18.9l5.7-10.8C862,414,853.1,408.7,850.3,407z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M870.1,417.3c1.2,0.6,13.2,4.3,13.2,4.3l-25.3,5.1L870.1,417.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M858.1,427c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1,0-0.3,0.1-0.4l12-9.4c0.1-0.1,0.2-0.1,0.3,0 c1.2,0.5,13.1,4.2,13.2,4.3c0.1,0,0.2,0.2,0.2,0.3c0,0.1-0.1,0.3-0.2,0.3L858.1,427C858.1,427,858.1,427,858.1,427z  M870.2,417.6l-10.9,8.5l22.8-4.6C879.2,420.6,871.7,418.2,870.2,417.6z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M843.5,669.1c-2.4,4.9-9.7,6.7-12,4.6c-2.6-2.4,0.5-10.1,4.7-14.3c1.2-1.2,2.5-2.5,3.9-2.2 C842.9,657.6,845.8,664.2,843.5,669.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M820.9,648.8c0.3,4.3,3.9,7,5,7.9c3,2.3,8.9,4.8,12.5,2.2c4.2-3,2.8-11.1,0.3-15.7 c-0.9-1.7-3.1-5.6-6.8-6.1C826.6,636.3,820.5,642.7,820.9,648.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M855.4,652.6c-2.7,6.5-13.3,9-15.8,6.2c-1.4-1.6-0.1-4.8,0.9-7.6c1.1-2.9,3-7.6,7.2-8.5 c2.2-0.5,5.2-0.1,7,2.1C857.3,647.7,855.5,652.2,855.4,652.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M842.9,656v2c0,1.6-1.3,3-3,3h-2c-1.6,0-3-1.4-3-3v-2c0-1.7,1.4-3,3-3h2C841.5,653,842.9,654.3,842.9,656z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M761.9,740.8h2.5v5.8h7.1v-5.8h2.5v14.5h-2.5v-6.4h-7.1v6.4h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M779,740.8h2.5v14.5H779V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M798.4,754.2c-1.3,0.8-3.1,1.3-5,1.3c-4.5,0-7.7-3.1-7.7-7.4c0-4.3,3.2-7.5,7.8-7.5c1.8,0,3.4,0.5,4.4,1.2 v2.7c-1.2-0.9-2.8-1.5-4.4-1.5c-3.2,0-5.3,2.3-5.3,5.2c0,2.8,2,5.2,5.3,5.2c0.9,0,1.7-0.2,2.4-0.5V750H793v-2.2h5.4V754.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M803.2,740.8h2.5v5.8h7.1v-5.8h2.5v14.5h-2.5v-6.4h-7.1v6.4h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M827.1,740.8h2.5v14.5h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M834.5,740.8h2.5l4.7,6.7l4.7-6.7h2.4v14.5h-2.5v-7.2c0-1.1,0-2.1,0-3.1l0,0c-0.6,0.9-1.2,1.8-1.9,2.8 l-2.7,3.9l-2.7-3.9c-0.7-1-1.3-1.9-1.9-2.8l0,0c0,1,0,2,0,3.1v7.2h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M853.8,740.8h4c1.6,0,3.1,0.1,4.3,0.8c1.3,0.7,2.2,1.9,2.2,3.7c0,1.7-0.8,3-2,3.7c-1.2,0.7-2.7,0.9-4.7,0.9 h-1.2v5.4h-2.5V740.8z M857.8,747.7c1.5,0,2.3-0.1,3-0.5c0.6-0.4,1-1,1-1.9c0-0.9-0.4-1.6-1.2-1.9c-0.7-0.4-1.6-0.4-2.9-0.4h-1.4 v4.7H857.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.5,755.3h-2.7l-1.4-3.5h-6.2l-1.4,3.5h-2.6l5.9-14.5h2.5L880.5,755.3z M871,749.7h4.6l-0.8-2.2 c-0.5-1.3-1-2.6-1.4-3.9h0c-0.5,1.3-0.9,2.6-1.4,3.9L871,749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M894.7,754.5c-1.2,0.7-2.8,1-4.2,1c-4.5,0-7.7-3.2-7.7-7.4c0-4.2,3.1-7.5,7.7-7.5c1.5,0,2.9,0.4,4,1v2.6 c-1.1-0.8-2.5-1.3-4-1.3c-3.1,0-5.2,2.2-5.2,5.2c0,2.9,2.1,5.1,5.3,5.1c1.5,0,3-0.5,4.1-1.4V754.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M902.7,743.1H898v-2.3H910v2.3h-4.8v12.2h-2.5V743.1z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1025.8,308.1c-1.1,0.6-2.5,0.9-3.8,0.9c-4.1,0-7-2.9-7-6.7c0-3.7,2.8-6.8,7-6.8c1.3,0,2.6,0.3,3.6,0.9v2.4 c-1-0.7-2.3-1.2-3.6-1.2c-2.8,0-4.7,2-4.7,4.6c0,2.6,1.9,4.6,4.8,4.6c1.4,0,2.7-0.5,3.7-1.3V308.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1029.1,302.4c0-3.8,2.9-6.7,6.7-6.7s6.7,2.9,6.7,6.7c0,3.8-2.9,6.7-6.7,6.7S1029.1,306.2,1029.1,302.4z  M1040.2,302.4c0-2.6-1.9-4.6-4.4-4.6s-4.4,2-4.4,4.6s1.9,4.6,4.4,4.6S1040.2,305,1040.2,302.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1049.5,303.6c1.4-1.7,2.1-2.8,2.1-3.9c0-1.3-0.9-2-2.2-2c-0.9,0-2,0.4-3,1.1v-2.2c0.7-0.5,1.8-0.9,3.2-0.9 c2.4,0,4.4,1.4,4.4,3.9c0,1.6-0.8,3-2.3,4.9l-1.9,2.4l0,0h4.6v2h-8.9l0,0L1049.5,303.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1063.4,295.2h1.7l-6.1,14.4h-1.7L1063.4,295.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1074.6,295.9h2.2l4.2,6.1l4.2-6.1h2.2v13h-2.3v-6.4c0-1,0-1.9,0-2.8l0,0c-0.5,0.8-1.1,1.6-1.7,2.5l-2.4,3.5 l-2.4-3.5c-0.6-0.9-1.2-1.7-1.7-2.5l0,0c0,0.9,0,1.8,0,2.8v6.4h-2.2V295.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1090.7,295.9h2.4l1.9,6.3c0.3,1.1,0.7,2.3,1,3.4h0c0.3-1.1,0.7-2.3,1-3.5l2-6.3h1.7l2,6.3 c0.4,1.3,0.7,2.3,1,3.4h0c0.3-1.1,0.6-2.3,1-3.5l1.9-6.3h2.3l-4,13h-2.4l-1.7-5.6c-0.3-1.1-0.6-2.1-0.9-3.1h0 c-0.3,1-0.6,2-0.9,3.1l-1.7,5.6h-2.4L1090.7,295.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1112.3,295.9h2.3v5.3h6.4v-5.3h2.3v13h-2.3v-5.7h-6.4v5.7h-2.3V295.9z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1014.3706 308.888)",
    className: "st14 st42 st43"
  }, "CO2/ MWh")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 759.6313 755.288)",
    className: "st14 st15 st16"
  }, "High Impact")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 727.3442 755.5078)",
    className: "st1 st14 st15 st16"
  }, "MOST CO2 AVOIDED"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Tx"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Texas_00000141434745549419581550000015526300088302135690_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 520.5,
    y: 636.8,
    className: "st22",
    width: 4,
    height: 62.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M521.9,646.5c4.7-0.6,25.5-6.2,31.6-19.5c7.3-16.1-1-17.6-1.6-22.1c-0.7-5.4,5.8-10.2,2.6-20.2 c-1.5-4.6-9-7.5-9.8-14.6c-0.7-6.9,6.1-10.9,4.9-20.5c-1.1-8.2-8.4-9.7-10.1-15c-1.3-4.1,1.6-8.4,0-12.4 c-3.3-8.2-11.3-1.6-15.3,3.9c-4.6,6.3-3,11.7-4.7,15.6c-1.9,4.3-13.8,10.1-17.2,16.2c-4.6,8.2,3.3,12.8,1,18.1 c-2,4.6-13.9,12.2-14.6,19.4c-0.6,5.8,7.7,10.7,7.7,16.5c0,2.9-3.6,7.1-1.3,13.3C499.9,638,518.6,645.6,521.9,646.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M525.8,569.3c-0.4,0-0.7,0.3-0.7,0.7c-2.6,25.2-3.4,49.9-3.2,74.2c0,0.4,0.3,0.8,0.7,0.8 c0.4,0,0.8-0.4,0.7-0.8c-0.3-24.2,0.6-48.8,3.2-74C526.6,569.6,526.2,569.3,525.8,569.3z M529.5,540c-0.3,0-0.6,0.3-0.7,0.6 c-1.1,6.9-2,13.7-2.8,20.5c-0.1,0.4,0.2,0.8,0.6,0.8c0.4,0,0.8-0.2,0.8-0.7c0.8-6.8,1.7-13.6,2.8-20.4 C530.3,540.4,530,540,529.5,540z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M508,656.1c-4.8,17.1-14.2,31.4-29.2,42.4h-15.2C469.4,676.5,486.4,664.3,508,656.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M483.2,624.8c0.8,28.2-4.2,53.4-18.6,73.7h-8.8C454.2,667.8,462.8,642.9,483.2,624.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M475.1,646.7c0.2,0,0.4,0.3,0.3,0.5c-6.7,17.5-10.3,32.9-14.5,51c0,0.2-0.2,0.3-0.4,0.3 c-0.2,0-0.3-0.2-0.3-0.4c4.2-18,7.8-33.5,14.5-51.1C474.8,646.8,474.9,646.7,475.1,646.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M447.1,637c8.2,18.9,16.2,37.9,13.2,61.5h-8.4C437,678.8,441.4,656.8,447.1,637z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M448.9,661.8c0.2,0,0.3,0.1,0.4,0.3c1.4,14.4,4.2,23.7,7.5,35.8c0.1,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4-0.1-0.4-0.3c-3.3-12.2-6.2-21.5-7.6-36C448.5,662,448.6,661.8,448.9,661.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M492.6,672.7c0.3,0,0.5,0.4,0.2,0.6c-9.8,8.9-15.6,15.5-22.7,24.9c-0.3,0.4-0.9-0.1-0.6-0.4 c7.2-9.4,13-16.1,22.8-25C492.4,672.7,492.5,672.7,492.6,672.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M585.7,528.3c-1.8,1.9-19.5,21.1-19.5,21.1l42.6-8.4L585.7,528.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M591.6,520.8c1.6-2.1,17.6-29.9,17.6-29.9l-0.4,50.1L591.6,520.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M588.3,577.3c-1.2-0.7-14.6-8.8-14.6-8.8l8.4,20.4L588.3,577.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M582.2,589.2C582.2,589.2,582.1,589.2,582.2,589.2c-0.1,0-0.2-0.1-0.3-0.2l-8.4-20.4 c-0.1-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4,0c0,0,13.4,8.1,14.6,8.8c0.1,0.1,0.2,0.3,0.1,0.4l-6.2,11.6 C582.4,589.1,582.3,589.2,582.2,589.2z M574.4,569.2l7.8,18.9l5.7-10.8C586.1,576.3,577.2,570.9,574.4,569.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M594.2,579.5c1.2,0.6,13.2,4.3,13.2,4.3l-25.3,5.1L594.2,579.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M582.2,589.2c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1,0-0.3,0.1-0.4l12-9.4c0.1-0.1,0.2-0.1,0.3,0 c1.2,0.5,13.1,4.2,13.2,4.3c0.1,0,0.2,0.2,0.2,0.3c0,0.1-0.1,0.3-0.2,0.3L582.2,589.2C582.2,589.2,582.2,589.2,582.2,589.2z  M594.2,579.9l-10.9,8.5l22.8-4.6C603.3,582.8,595.8,580.5,594.2,579.9z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M557.5,686.7c-3.9,2.7-10.3,10-6.1,12c5.1,2.5,21.8,2.1,26.3-2.4c3.3-3.3-1.5-9.7-5.7-11.7 C567.9,682.6,561.5,684,557.5,686.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M601.5,691.9c-2.2,1.5-5.8,5.6-3.4,6.8c2.9,1.4,12.3,1.2,14.8-1.4c1.9-1.9-0.8-5.5-3.2-6.6 C607.3,689.6,603.7,690.4,601.5,691.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st37",
    x1: 586.5,
    y1: 663.5,
    x2: 586.5,
    y2: 699.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M573.9,659.6c-4.6-2.9-5.6-10.3-3.3-12.4c2.6-2.3,10,1.6,13.7,6.1c1.1,1.3,2.2,2.7,1.8,4.1 C585.4,660.3,578.5,662.5,573.9,659.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M596.5,639.3c-4.3-0.1-7.4,3.1-8.4,4.1c-2.6,2.8-5.7,8.4-3.5,12.2c2.6,4.5,10.8,3.9,15.5,1.9 c1.8-0.7,5.9-2.4,6.8-6.1C608.3,646.3,602.6,639.5,596.5,639.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M589.1,673.2c-6.2-3.4-7.5-14.2-4.5-16.4c1.7-1.2,4.8,0.4,7.5,1.7c2.7,1.4,7.2,3.7,7.7,8.1 c0.3,2.2-0.5,5.2-2.8,6.7C593.7,675.6,589.5,673.4,589.1,673.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M587,660.4l-2-0.2c-1.6-0.2-2.8-1.7-2.7-3.3l0.2-2c0.2-1.6,1.7-2.8,3.3-2.7l2,0.2c1.6,0.2,2.8,1.7,2.7,3.3 l-0.2,2C590.2,659.4,588.7,660.6,587,660.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.2,740.8h2.5l4.7,6.7l4.7-6.7h2.4v14.5H434v-7.2c0-1.1,0-2.1,0-3.1l0,0c-0.6,0.9-1.2,1.8-1.9,2.8 l-2.7,3.9l-2.7-3.9c-0.7-1-1.3-1.9-1.9-2.8l0,0c0,1,0,2,0,3.1v7.2h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.8,748c0-4.2,3.2-7.5,7.5-7.5s7.5,3.2,7.5,7.5c0,4.2-3.2,7.5-7.5,7.5S440.8,752.3,440.8,748z M453.1,748 c0-2.9-2.1-5.1-4.9-5.1s-4.9,2.3-4.9,5.1c0,2.9,2.1,5.1,4.9,5.1S453.1,750.9,453.1,748z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459.9,740.8h4c2.2,0,4.1,0.4,5.6,1.3c1.9,1.2,3,3.4,3,5.9c0,2.4-1,4.4-2.6,5.7c-1.5,1.1-3.5,1.6-6.3,1.6 h-3.7V740.8z M463.8,753c1.9,0,3.3-0.3,4.3-1c1.1-0.8,1.9-2.2,1.9-4c0-1.8-0.8-3.2-2-4c-1.1-0.8-2.6-0.9-4.2-0.9h-1.4v10H463.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.7,740.8h8.6v2.3h-6.1v3.6h5.3v2.2h-5.3v4.2h6.3v2.3h-8.8V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489.8,740.8h4.2c1.5,0,2.9,0.1,4.1,0.7c1.2,0.6,2.1,1.8,2.1,3.5c0,2-1.2,3.5-3.2,4l4.4,6.3h-3l-4-6h-1.9v6 h-2.5V740.8z M494.4,747.3c1.2,0,1.9-0.2,2.5-0.6c0.5-0.3,0.7-0.8,0.7-1.6c0-0.9-0.4-1.4-1-1.7c-0.6-0.3-1.4-0.4-2.7-0.4h-1.5v4.3 H494.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M518,755.3h-2.7l-1.4-3.5h-6.2l-1.4,3.5h-2.6l5.9-14.5h2.5L518,755.3z M508.5,749.7h4.6l-0.8-2.2 c-0.5-1.3-1-2.6-1.4-3.9h0c-0.5,1.3-0.9,2.6-1.4,3.9L508.5,749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M523.4,743.1h-4.7v-2.3h12.1v2.3h-4.8v12.2h-2.5V743.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.5,740.8h8.6v2.3h-6.1v3.6h5.3v2.2h-5.3v4.2h6.3v2.3h-8.8V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M554.5,740.8h2.5v14.5h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M561.9,740.8h2.5l4.7,6.7l4.7-6.7h2.4v14.5h-2.5v-7.2c0-1.1,0-2.1,0-3.1l0,0c-0.6,0.9-1.2,1.8-1.9,2.8 l-2.7,3.9l-2.7-3.9c-0.7-1-1.3-1.9-1.9-2.8l0,0c0,1,0,2,0,3.1v7.2h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.2,740.8h4c1.6,0,3.1,0.1,4.3,0.8c1.3,0.7,2.2,1.9,2.2,3.7c0,1.7-0.8,3-2,3.7c-1.2,0.7-2.7,0.9-4.7,0.9 h-1.2v5.4h-2.5V740.8z M585.2,747.7c1.5,0,2.3-0.1,3-0.5c0.6-0.4,1-1,1-1.9c0-0.9-0.4-1.6-1.2-1.9c-0.7-0.4-1.6-0.4-2.9-0.4h-1.4 v4.7H585.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M607.9,755.3h-2.7l-1.4-3.5h-6.2l-1.4,3.5h-2.6l5.9-14.5h2.5L607.9,755.3z M598.4,749.7h4.6l-0.8-2.2 c-0.5-1.3-1-2.6-1.4-3.9h0c-0.5,1.3-0.9,2.6-1.4,3.9L598.4,749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M622.1,754.5c-1.2,0.7-2.8,1-4.2,1c-4.5,0-7.7-3.2-7.7-7.4c0-4.2,3.1-7.5,7.7-7.5c1.5,0,2.9,0.4,4,1v2.6 c-1.1-0.8-2.5-1.3-4-1.3c-3.1,0-5.2,2.2-5.2,5.2c0,2.9,2.1,5.1,5.3,5.1c1.5,0,3-0.5,4.1-1.4V754.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M630.1,743.1h-4.7v-2.3h12.1v2.3h-4.8v12.2h-2.5V743.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1014.3706 496.888)",
    className: "st0 st14 st42 st43"
  }, "CO2/ MWh"), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1025.8,496.1c-1.1,0.6-2.5,0.9-3.8,0.9c-4.1,0-7-2.9-7-6.7c0-3.7,2.8-6.8,7-6.8c1.3,0,2.6,0.3,3.6,0.9v2.4 c-1-0.7-2.3-1.2-3.6-1.2c-2.8,0-4.7,2-4.7,4.6c0,2.6,1.9,4.6,4.8,4.6c1.4,0,2.7-0.5,3.7-1.3V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1029.1,490.4c0-3.8,2.9-6.7,6.7-6.7s6.7,2.9,6.7,6.7c0,3.8-2.9,6.7-6.7,6.7S1029.1,494.2,1029.1,490.4z  M1040.2,490.4c0-2.6-1.9-4.6-4.4-4.6s-4.4,2-4.4,4.6s1.9,4.6,4.4,4.6S1040.2,493,1040.2,490.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1049.5,491.6c1.4-1.7,2.1-2.8,2.1-3.9c0-1.3-0.9-2-2.2-2c-0.9,0-2,0.4-3,1.1v-2.2c0.7-0.5,1.8-0.9,3.2-0.9 c2.4,0,4.4,1.4,4.4,3.9c0,1.6-0.8,3-2.3,4.9l-1.9,2.4l0,0h4.6v2h-8.9l0,0L1049.5,491.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1063.4,483.2h1.7l-6.1,14.4h-1.7L1063.4,483.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1074.6,483.9h2.2l4.2,6.1l4.2-6.1h2.2v13h-2.3v-6.4c0-1,0-1.9,0-2.8l0,0c-0.5,0.8-1.1,1.6-1.7,2.5l-2.4,3.5 l-2.4-3.5c-0.6-0.9-1.2-1.7-1.7-2.5l0,0c0,0.9,0,1.8,0,2.8v6.4h-2.2V483.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1090.7,483.9h2.4l1.9,6.3c0.3,1.1,0.7,2.3,1,3.4h0c0.3-1.1,0.7-2.3,1-3.5l2-6.3h1.7l2,6.3 c0.4,1.3,0.7,2.3,1,3.4h0c0.3-1.1,0.6-2.3,1-3.5l1.9-6.3h2.3l-4,13h-2.4l-1.7-5.6c-0.3-1.1-0.6-2.1-0.9-3.1h0 c-0.3,1-0.6,2-0.9,3.1l-1.7,5.6h-2.4L1090.7,483.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1112.3,483.9h2.3v5.3h6.4v-5.3h2.3v13h-2.3v-5.7h-6.4v5.7h-2.3V483.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 419.2231 755.288)",
    className: "st0 st14 st15 st16"
  }, "Moderate impact"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391,740.8h2.5l4.7,6.7l4.7-6.7h2.4v14.5h-2.5v-7.2c0-1.1,0-2.1,0-3.1l0,0c-0.6,0.9-1.2,1.8-1.9,2.8l-2.7,3.9l-2.7-3.9 c-0.7-1-1.3-1.9-1.9-2.8l0,0c0,1,0,2,0,3.1v7.2H391V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.6,748c0-4.2,3.2-7.5,7.5-7.5c4.3,0,7.5,3.2,7.5,7.5c0,4.2-3.2,7.5-7.5,7.5C412.8,755.5,409.6,752.3,409.6,748z  M421.9,748c0-2.9-2.1-5.1-4.9-5.1c-2.8,0-4.9,2.3-4.9,5.1c0,2.9,2.1,5.1,4.9,5.1C419.8,753.2,421.9,750.9,421.9,748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.7,740.8h4c2.2,0,4.1,0.4,5.6,1.3c1.9,1.2,3,3.4,3,5.9c0,2.4-1,4.4-2.6,5.7c-1.5,1.1-3.5,1.6-6.3,1.6h-3.7V740.8z  M432.6,753c1.9,0,3.3-0.3,4.3-1c1.1-0.8,1.9-2.2,1.9-4c0-1.8-0.8-3.2-2-4c-1.1-0.8-2.6-0.9-4.2-0.9h-1.4v10H432.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.5,740.8h8.6v2.3H448v3.6h5.3v2.2H448v4.2h6.3v2.3h-8.8V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,740.8h4.2c1.5,0,2.9,0.1,4.1,0.7c1.2,0.6,2.1,1.8,2.1,3.5c0,2-1.2,3.5-3.2,4l4.4,6.3h-3l-4-6h-1.9v6h-2.5V740.8z  M463.2,747.3c1.2,0,1.9-0.2,2.5-0.6c0.5-0.3,0.7-0.8,0.7-1.6c0-0.9-0.4-1.4-1-1.7c-0.6-0.3-1.4-0.4-2.7-0.4h-1.5v4.3H463.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.8,755.3h-2.7l-1.4-3.5h-6.2l-1.4,3.5h-2.6l5.9-14.5h2.5L486.8,755.3z M477.3,749.7h4.6l-0.8-2.2 c-0.5-1.3-1-2.6-1.4-3.9h0c-0.5,1.3-0.9,2.6-1.4,3.9L477.3,749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.2,743.1h-4.7v-2.3h12.1v2.3h-4.8v12.2h-2.5V743.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.3,740.8h8.6v2.3h-6.1v3.6h5.3v2.2h-5.3v4.2h6.3v2.3h-8.8V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.5,754.5c-1.2,0.7-2.8,1-4.2,1c-4.5,0-7.7-3.2-7.7-7.4c0-4.2,3.1-7.5,7.7-7.5c1.5,0,2.9,0.4,4,1v2.6 c-1.1-0.8-2.5-1.3-4-1.3c-3.1,0-5.2,2.2-5.2,5.2c0,2.9,2.1,5.1,5.3,5.1c1.5,0,3-0.5,4.1-1.4V754.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.1,748c0-4.2,3.2-7.5,7.5-7.5c4.3,0,7.5,3.2,7.5,7.5c0,4.2-3.2,7.5-7.5,7.5C541.3,755.5,538.1,752.3,538.1,748z  M550.5,748c0-2.9-2.1-5.1-4.9-5.1c-2.8,0-4.9,2.3-4.9,5.1c0,2.9,2.1,5.1,4.9,5.1C548.4,753.2,550.5,750.9,550.5,748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.8,749.4c1.5-1.9,2.3-3.1,2.3-4.3c0-1.5-1-2.2-2.5-2.2c-1,0-2.3,0.4-3.3,1.2v-2.4c0.8-0.5,2-1,3.5-1 c2.7,0,4.9,1.6,4.9,4.3c0,1.8-0.9,3.4-2.5,5.4L561,753l0,0h5.1v2.3h-9.9l0,0L560.8,749.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.5,755.3h-2.7l-1.4-3.5h-6.2l-1.4,3.5h-2.6l5.9-14.5h2.5L590.5,755.3z M581,749.7h4.6l-0.8-2.2 c-0.5-1.3-1-2.6-1.4-3.9h0c-0.5,1.3-0.9,2.6-1.4,3.9L581,749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.9,740.8h2.7l2.7,7.1c0.5,1.3,1,2.7,1.5,4.1h0c0.5-1.3,1-2.7,1.5-4.1l2.7-7.1h2.6l-5.5,14.5h-2.6L590.9,740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.6,748c0-4.2,3.2-7.5,7.5-7.5c4.3,0,7.5,3.2,7.5,7.5c0,4.2-3.2,7.5-7.5,7.5C609.8,755.5,606.6,752.3,606.6,748z  M619,748c0-2.9-2.1-5.1-4.9-5.1c-2.8,0-4.9,2.3-4.9,5.1c0,2.9,2.1,5.1,4.9,5.1C616.9,753.2,619,750.9,619,748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.8,740.8h2.5v14.5h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.2,740.8h4c2.2,0,4.1,0.4,5.6,1.3c1.9,1.2,3,3.4,3,5.9c0,2.4-1,4.4-2.6,5.7c-1.5,1.1-3.5,1.6-6.3,1.6h-3.7V740.8z  M637.2,753c1.9,0,3.3-0.3,4.3-1c1.1-0.8,1.9-2.2,1.9-4c0-1.8-0.8-3.2-2-4c-1.1-0.8-2.6-0.9-4.2-0.9h-1.4v10H637.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650,740.8h8.6v2.3h-6.1v3.6h5.3v2.2h-5.3v4.2h6.3v2.3H650V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.1,740.8h4c2.2,0,4.1,0.4,5.6,1.3c1.9,1.2,3,3.4,3,5.9c0,2.4-1,4.4-2.6,5.7c-1.5,1.1-3.5,1.6-6.3,1.6h-3.7V740.8z  M667.1,753c1.9,0,3.3-0.3,4.3-1c1.1-0.8,1.9-2.2,1.9-4c0-1.8-0.8-3.2-2-4c-1.1-0.8-2.6-0.9-4.2-0.9h-1.4v10H667.1z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Cali",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "California",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 284.6,
    y1: 607,
    x2: 284.6,
    y2: 702.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M284.6,607l-26.9-26.9C272.6,580.1,284.6,592.1,284.6,607"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M284.6,569.8c10.5,10.5,10.5,27.5,0,38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M284.6,607.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 284.6,
    y1: 607.8,
    x2: 284.6,
    y2: 569.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M274.5,626c-6.1,86.2-22.8,73-55.1,75.4c-14,1-18-22.3-31.6-26.1c-10.3-0.9-23.2-10.5-10.9-19.3 c8.8-10.3,22.6,1.8,19.2-10.6c-7.6-14.9-23.3-30.3-8.9-46.9c1.4-1.9,3.6-2.4,5.5-0.8c18.2,12.7,18.5,37.7,27.8,56.1 c3.3,7.6,10.9,4.8,9-3.2c-1.3-12.4-13.2-19.4-16.9-30.5c-3.1-16.7,14.3-17.1,21-4.9c4.7,5.4,8.6-6.9,11.1-9.9 c4-7.2,14.9-6.9,14.7,2.3c-2.5,13.6-9.7,26.3-14,39.5c-1.5,5.1-5.2,11.2-3.1,16.4C252.6,665.6,263.6,631.2,274.5,626z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M194.3,609.5c0,0,22.3,52.6,37.7,91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M225.2,683.9c0,0-20.6-23.9-40.7-23.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M232,700.5c-1.5-13.4,4.9-40.2,7.1-55.1c0,0,0,0,0,0c1.3-9.2,3.7-17.9,7.7-25.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M239.1,645.4c0,0-5.7-18.1-14.8-27.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M232,700.5c3.6-7.8,21.5-35.6,36.4-53.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M304.7,688.2c-2.9,2-7.6,7.3-4.5,8.9c3.8,1.9,16.1,1.6,19.5-1.8c2.4-2.4-1.1-7.2-4.2-8.7 C312.3,685.1,307.6,686.2,304.7,688.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st37",
    x1: 151.5,
    y1: 664,
    x2: 151.5,
    y2: 700
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M158.6,671c-2.1,5.1-9.2,7.3-11.6,5.4c-2.7-2.2-0.2-10.1,3.6-14.6c1.1-1.3,2.3-2.6,3.7-2.5 C157.2,659.6,160.6,666,158.6,671z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M134.6,652.4c0.6,4.3,4.4,6.7,5.5,7.5c3.2,2.1,9.2,4.1,12.7,1.3c4-3.3,1.9-11.3-0.8-15.6 c-1-1.6-3.5-5.4-7.3-5.6C139.4,639.5,133.8,646.3,134.6,652.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M169.3,653.7c-2.2,6.7-12.7,9.9-15.3,7.3c-1.5-1.5-0.5-4.8,0.4-7.6c0.9-2.9,2.4-7.8,6.6-9 c2.1-0.6,5.2-0.4,7.1,1.6C170.8,648.7,169.4,653.3,169.3,653.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M157.1,658l0.1,2c0.1,1.6-1.1,3.1-2.8,3.2l-2,0.1c-1.6,0.1-3.1-1.1-3.2-2.8l-0.1-2 c-0.1-1.6,1.1-3.1,2.8-3.2l2-0.1C155.5,655.1,156.9,656.3,157.1,658z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142,740.8h2.5V753h6.6v2.3H142V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.8,748c0-4.2,3.2-7.5,7.5-7.5c4.3,0,7.5,3.2,7.5,7.5c0,4.2-3.2,7.5-7.5,7.5 C157,755.5,153.8,752.3,153.8,748z M166.2,748c0-2.9-2.1-5.1-4.9-5.1c-2.8,0-4.9,2.3-4.9,5.1c0,2.9,2.1,5.1,4.9,5.1 C164.1,753.2,166.2,750.9,166.2,748z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.1,740.8h2.7l2.1,7c0.4,1.3,0.8,2.6,1.1,3.8h0c0.3-1.2,0.8-2.6,1.1-3.8l2.2-7h1.9l2.2,7 c0.4,1.4,0.8,2.5,1.1,3.8h0c0.3-1.2,0.7-2.6,1.1-3.8l2.1-7h2.6l-4.5,14.5h-2.7l-1.9-6.2c-0.4-1.2-0.7-2.4-1-3.5h0 c-0.3,1.1-0.7,2.3-1,3.4l-1.9,6.2h-2.7L171.1,740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.8,740.8h2.5v14.5h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.3,740.8h2.5l4.7,6.7l4.7-6.7h2.4v14.5h-2.5v-7.2c0-1.1,0-2.1,0-3.1l0,0c-0.6,0.9-1.2,1.8-1.9,2.8 l-2.7,3.9l-2.7-3.9c-0.7-1-1.3-1.9-1.9-2.8l0,0c0,1,0,2,0,3.1v7.2h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.6,740.8h4c1.6,0,3.1,0.1,4.3,0.8c1.3,0.7,2.2,1.9,2.2,3.7c0,1.7-0.8,3-2,3.7c-1.2,0.7-2.7,0.9-4.7,0.9 h-1.2v5.4h-2.5V740.8z M232.6,747.7c1.5,0,2.3-0.1,3-0.5c0.6-0.4,1-1,1-1.9c0-0.9-0.4-1.6-1.2-1.9c-0.7-0.4-1.6-0.4-2.9-0.4h-1.4 v4.7H232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,755.3h-2.7l-1.4-3.5H245l-1.4,3.5h-2.6l5.9-14.5h2.5L255.3,755.3z M245.8,749.7h4.6l-0.8-2.2 c-0.5-1.3-1-2.6-1.4-3.9h0c-0.5,1.3-0.9,2.6-1.4,3.9L245.8,749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.5,754.5c-1.2,0.7-2.8,1-4.2,1c-4.5,0-7.7-3.2-7.7-7.4c0-4.2,3.1-7.5,7.7-7.5c1.5,0,2.9,0.4,4,1v2.6 c-1.1-0.8-2.5-1.3-4-1.3c-3.1,0-5.2,2.2-5.2,5.2c0,2.9,2.1,5.1,5.3,5.1c1.5,0,3-0.5,4.1-1.4V754.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.5,743.1h-4.7v-2.3h12.1v2.3H280v12.2h-2.5V743.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1014.3706 685.888)",
    className: "st14 st42 st43"
  }, "CO2/ MWh"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1025.8,685.1c-1.1,0.6-2.5,0.9-3.8,0.9c-4.1,0-7-2.9-7-6.7c0-3.7,2.8-6.8,7-6.8c1.3,0,2.6,0.3,3.6,0.9v2.4 c-1-0.7-2.3-1.2-3.6-1.2c-2.8,0-4.7,2-4.7,4.6c0,2.6,1.9,4.6,4.8,4.6c1.4,0,2.7-0.5,3.7-1.3V685.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1029.1,679.4c0-3.8,2.9-6.7,6.7-6.7s6.7,2.9,6.7,6.7c0,3.8-2.9,6.7-6.7,6.7S1029.1,683.2,1029.1,679.4z  M1040.2,679.4c0-2.6-1.9-4.6-4.4-4.6s-4.4,2-4.4,4.6s1.9,4.6,4.4,4.6S1040.2,682,1040.2,679.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1049.5,680.6c1.4-1.7,2.1-2.8,2.1-3.9c0-1.3-0.9-2-2.2-2c-0.9,0-2,0.4-3,1.1v-2.2c0.7-0.5,1.8-0.9,3.2-0.9 c2.4,0,4.4,1.4,4.4,3.9c0,1.6-0.8,3-2.3,4.9l-1.9,2.4l0,0h4.6v2h-8.9l0,0L1049.5,680.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1063.4,672.2h1.7l-6.1,14.4h-1.7L1063.4,672.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1074.6,672.9h2.2l4.2,6.1l4.2-6.1h2.2v13h-2.3v-6.4c0-1,0-1.9,0-2.8l0,0c-0.5,0.8-1.1,1.6-1.7,2.5l-2.4,3.5 l-2.4-3.5c-0.6-0.9-1.2-1.7-1.7-2.5l0,0c0,0.9,0,1.8,0,2.8v6.4h-2.2V672.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1090.7,672.9h2.4l1.9,6.3c0.3,1.1,0.7,2.3,1,3.4h0c0.3-1.1,0.7-2.3,1-3.5l2-6.3h1.7l2,6.3 c0.4,1.3,0.7,2.3,1,3.4h0c0.3-1.1,0.6-2.3,1-3.5l1.9-6.3h2.3l-4,13h-2.4l-1.7-5.6c-0.3-1.1-0.6-2.1-0.9-3.1h0 c-0.3,1-0.6,2-0.9,3.1l-1.7,5.6h-2.4L1090.7,672.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1112.3,672.9h2.3v5.3h6.4v-5.3h2.3v13h-2.3v-5.7h-6.4v5.7h-2.3V672.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 139.2568 755.288)",
    className: "st14 st15 st16"
  }, "Low impact"), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.1,740.8h2.5V753h6.6v2.3h-9.1V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.1,740.8h8.6v2.3h-6.1v3.6h5.3v2.2h-5.3v4.2h6.3v2.3h-8.8V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,751.7c1.5,1,3.3,1.5,4.5,1.5c1.4,0,2.5-0.6,2.5-2c0-1.6-1.5-1.8-3.4-2.4c-2-0.6-3.9-1.5-3.9-4.1 c0-2.6,2-4.2,4.9-4.2c1.4,0,3.1,0.3,4.3,1.1v2.6c-1.4-0.9-3.1-1.4-4.3-1.4c-1.4,0-2.3,0.5-2.3,1.8c0,1.5,1.5,1.7,3.3,2.3 c2.1,0.7,4.1,1.6,4.1,4.3c0,2.7-2,4.4-5,4.4c-1.4,0-3.2-0.4-4.5-1.1V751.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3,751.7c1.5,1,3.3,1.5,4.5,1.5c1.4,0,2.5-0.6,2.5-2c0-1.6-1.5-1.8-3.4-2.4c-2-0.6-3.9-1.5-3.9-4.1 c0-2.6,2-4.2,4.9-4.2c1.4,0,3.1,0.3,4.3,1.1v2.6c-1.4-0.9-3.1-1.4-4.3-1.4c-1.4,0-2.3,0.5-2.3,1.8c0,1.5,1.5,1.7,3.3,2.3 c2.1,0.7,4.1,1.6,4.1,4.3c0,2.7-2,4.4-5,4.4c-1.4,0-3.2-0.4-4.5-1.1V751.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,754.5c-1.2,0.7-2.8,1-4.2,1c-4.5,0-7.7-3.2-7.7-7.4c0-4.2,3.1-7.5,7.7-7.5c1.5,0,2.9,0.4,4,1v2.6 c-1.1-0.8-2.5-1.3-4-1.3c-3.1,0-5.2,2.2-5.2,5.2c0,2.9,2.1,5.1,5.3,5.1c1.5,0,3-0.5,4.1-1.4V754.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,748c0-4.2,3.2-7.5,7.5-7.5c4.3,0,7.5,3.2,7.5,7.5c0,4.2-3.2,7.5-7.5,7.5C184.9,755.5,181.7,752.3,181.7,748z  M194.1,748c0-2.9-2.1-5.1-4.9-5.1c-2.8,0-4.9,2.3-4.9,5.1c0,2.9,2.1,5.1,4.9,5.1C192,753.2,194.1,750.9,194.1,748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.4,749.4c1.5-1.9,2.3-3.1,2.3-4.3c0-1.5-1-2.2-2.5-2.2c-1,0-2.3,0.4-3.3,1.2v-2.4c0.8-0.5,2-1,3.5-1 c2.7,0,4.9,1.6,4.9,4.3c0,1.8-0.9,3.4-2.5,5.4l-2.1,2.7l0,0h5.1v2.3h-9.9l0,0L204.4,749.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,755.3h-2.7l-1.4-3.5h-6.2l-1.4,3.5h-2.6l5.9-14.5h2.5L234,755.3z M224.5,749.7h4.6l-0.8-2.2c-0.5-1.3-1-2.6-1.4-3.9 h0c-0.5,1.3-0.9,2.6-1.4,3.9L224.5,749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,740.8h2.7l2.7,7.1c0.5,1.3,1,2.7,1.5,4.1h0c0.5-1.3,1-2.7,1.5-4.1l2.7-7.1h2.6l-5.5,14.5H240L234.5,740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2,748c0-4.2,3.2-7.5,7.5-7.5c4.3,0,7.5,3.2,7.5,7.5c0,4.2-3.2,7.5-7.5,7.5C253.4,755.5,250.2,752.3,250.2,748z  M262.6,748c0-2.9-2.1-5.1-4.9-5.1c-2.8,0-4.9,2.3-4.9,5.1c0,2.9,2.1,5.1,4.9,5.1C260.5,753.2,262.6,750.9,262.6,748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3,740.8h2.5v14.5h-2.5V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.8,740.8h4c2.2,0,4.1,0.4,5.6,1.3c1.9,1.2,3,3.4,3,5.9c0,2.4-1,4.4-2.6,5.7c-1.5,1.1-3.5,1.6-6.3,1.6h-3.7V740.8z  M280.7,753c1.9,0,3.3-0.3,4.3-1c1.1-0.8,1.9-2.2,1.9-4c0-1.8-0.8-3.2-2-4c-1.1-0.8-2.6-0.9-4.2-0.9h-1.4v10H280.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,740.8h8.6v2.3h-6.1v3.6h5.3v2.2h-5.3v4.2h6.3v2.3h-8.8V740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7,740.8h4c2.2,0,4.1,0.4,5.6,1.3c1.9,1.2,3,3.4,3,5.9c0,2.4-1,4.4-2.6,5.7c-1.5,1.1-3.5,1.6-6.3,1.6h-3.7V740.8z  M310.6,753c1.9,0,3.3-0.3,4.3-1c1.1-0.8,1.9-2.2,1.9-4c0-1.8-0.8-3.2-2-4c-1.1-0.8-2.6-0.9-4.2-0.9h-1.4v10H310.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumImpact);
export default __webpack_public_path__ + "static/media/MediumImpact.7c71d85681b898477d365776502bedd7.svg";
export { ForwardRef as ReactComponent };